import _ from 'lodash';
import { combineReducers } from 'redux';

import types from 'frontend/state/actionTypes';

const idReducer = (state = 0, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_TALENT_SET:
      return payload.id;
    default:
      return state;
  }
};

const talentsReducer = (state = '0000000', action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_TALENT_SET:
      return payload.talents || '0000000';
    case types.CHOOSE_TALENT: {
      const { row, col } = payload;
      const newState = _.toArray(state);
      const current = parseInt(newState[row]);
      const newCol = parseInt(col) + 1;
      newState[row] = current === newCol ? '0' : newCol;
      return newState.join('');
    }
    default:
      return state;
  }
};

const nameReducer = (state = null, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_TALENT_SET_NAME: {
      return payload.name;
    }
    default:
      return state;
  }
};

export default combineReducers({
  id: idReducer,
  talents: talentsReducer,
  name: nameReducer,
});

export function validName(talentSet) {
  return (talentSet && !_.includes(talentSet.name, ',') && !_.includes(talentSet.name, '"'));
}
